class HaddadOutdoorKitchens {
  constructor(root) {
    this.root = root;
    this.cinematic = root.querySelector('[data-hok-cinematic]');
    this.modal = root.querySelector('[data-hok-modal]');
    this.video = root.querySelector('.hok-video-moment video');
    this.ticking = false;
    this.onScroll = this.onScroll.bind(this);
    root.querySelectorAll('[data-hok-open]').forEach((button) => button.addEventListener('click', () => this.open()));
    root.querySelectorAll('[data-hok-close]').forEach((button) => button.addEventListener('click', () => this.close()));
    this.modal.addEventListener('click', (event) => { if (event.target === this.modal) this.close(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !this.modal.hidden) this.close(); });
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
    this.update();
    requestAnimationFrame(() => this.update());
    if (this.video) {
      this.video.muted = true;
      this.video.play().catch(() => {});
    }
    if (this.modal.querySelector('.hok-success')) this.open();
  }
  onScroll() {
    if (this.ticking) return;
    requestAnimationFrame(() => { this.update(); this.ticking = false; });
    this.ticking = true;
  }
  update() {
    const rect = this.cinematic.getBoundingClientRect();
    const range = this.cinematic.offsetHeight - window.innerHeight;
    const p = Math.max(0, Math.min(1, -rect.top / Math.max(1, range)));
    const stage = (start, length) => Math.max(0, Math.min(1, (p - start) / length));
    this.cinematic.style.setProperty('--p', p.toFixed(4));
    this.cinematic.style.setProperty('--i', stage(0, .24).toFixed(4));
    this.cinematic.style.setProperty('--r', stage(.15, .20).toFixed(4));
    const videoIn = stage(.27, .10);
    const videoOut = stage(.43, .10);
    this.cinematic.style.setProperty('--v', Math.max(0, Math.min(1, videoIn * (1 - videoOut))).toFixed(4));
    this.cinematic.style.setProperty('--a', stage(.48, .32).toFixed(4));
    this.cinematic.style.setProperty('--f', stage(.78, .22).toFixed(4));
  }
  open() {
    this.modal.hidden = false;
    document.documentElement.classList.add('hok-modal-open');
    requestAnimationFrame(() => this.modal.querySelector('input, select, textarea')?.focus());
  }
  close() {
    this.modal.hidden = true;
    document.documentElement.classList.remove('hok-modal-open');
  }
}
function initHaddadOutdoorKitchens(scope = document) {
  const roots = [];
  if (scope.matches && scope.matches('[data-hok-section]')) roots.push(scope);
  if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('[data-hok-section]'));
  roots.forEach((root) => {
    if (!root.dataset.hokReady) {
      root.dataset.hokReady = 'true';
      new HaddadOutdoorKitchens(root);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initHaddadOutdoorKitchens());
} else {
  initHaddadOutdoorKitchens();
}

document.addEventListener('shopify:section:load', (event) => initHaddadOutdoorKitchens(event.target));